import { Box, Grid, Typography } from '@mui/material';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import ListAltIcon from '@mui/icons-material/ListAlt';
import QuickActionCard from '@/components/ui/QuickActionCard.tsx';

export default function PsiHome() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Bienvenido PSI
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Selecciona una opción para empezar
      </Typography>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} sm={6} md={3}>
          <QuickActionCard title="Operaciones" icon={<ListAltIcon />} to="/inversiones" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <QuickActionCard title="Oportunidades" icon={<HomeWorkIcon />} to="/oportunidades" />
        </Grid>
      </Grid>
    </Box>
  );
}
